import type { OrganizationType } from '../types/organization';
import type { OptionsType } from '../types/options';
import type { OrganizationUserType } from '../types/user';

type CREATE = 'CREATE';
type UPDATE = 'UPDATE';
// createとupdateを分ける必要が出てきたら：
// type UserIdParams<T extends CREATE | UPDATE> = T extends CREATE ? undefined : string;
// type OrganizationUserParams<T extends CREATE | UPDATE> = T extends CREATE ? CreateOrganizationUserParams : UpdateOrganizationUserParams;

/**
 * 選ばれた組織（OrganizationType）から OrganizationUserType を作成する。
 * ※UPDATE時にはuserIdを含める必要がある（CREATE時には不要）。
 * @param organization [OrganizationType] - 選択された組織
 * @param dialogMode [string] - モーダルのモード（'CREATE', 'UPDATTE', 'DELETE'）
 * @param userId [string | undefined] - CREATE時にはundefined
 * @returns [OrganizationUserType]
 */
const getOrganizationUser = <T extends CREATE | UPDATE>(baseName: string, tradingCompany: OptionsType, organization: OrganizationType, dialogMode: T): OrganizationUserType => {
  // organizationを整形する（idがorganizationIdになる）
  const tempOrg = { ...organization };
  const tempOrgId: number = tempOrg.id; // organizationIdとして利用するために取っておく
  delete tempOrg.id;

  const organizationUser: OrganizationUserType = {
    ...tempOrg,
    organizationBaseName: baseName,
    organizationId: tempOrgId,
    emailNotificationFlag: false,
    emailNotificationCustomers: [],
    tradingCompanyNameJa: tradingCompany.nameJapanese ?? '',
    tradingCompanyNameEn: tradingCompany.nameEnglish ?? tradingCompany?.nameJapanese ?? '',
  };
  // console.log(organizationUser);
  return organizationUser;
};

export default getOrganizationUser;
